module.exports = __webpack_public_path__ + "static/trees-3.9-46bb59001caa62be2a1d579bd32efd7a.png";